import SearchIcon from '@mui/icons-material/Search';
import {
  Autocomplete,
  InputAdornment,
  TextField,
  debounce,
} from '@mui/material';

export type SelectOption = {
  value: string;
  label: string;
};

type SearchBarProps = {
  label: string;
  setSearchTerm: (searchTerm: SelectOption | string) => void;
  setTypeaheadSearchTerm?: (searchTerm: string) => void;
  options?: string[] | SelectOption[];
  value?: string;
  isLoading?: boolean;
  disabled?: boolean;
};

export const SearchBar = ({
  label,
  options,
  setSearchTerm,
  setTypeaheadSearchTerm,
  value,
  isLoading = false,
  disabled,
}: SearchBarProps) => {
  const onUserChangedSearchTerm = setTypeaheadSearchTerm
    ? debounce(setTypeaheadSearchTerm, 500)
    : () => null;

  return (
    <Autocomplete
      freeSolo
      selectOnFocus
      disabled={disabled}
      options={options.map(option => (option.label ? { ...option } : option))}
      getOptionDisabled={() => isLoading}
      getOptionLabel={option => {
        if (typeof option === 'string') {
          return option;
        } else {
          return option.label;
        }
      }}
      filterOptions={options => options}
      onChange={(event, option) => setSearchTerm(option)}
      onInputChange={(event: any) => {
        onUserChangedSearchTerm(event?.target?.value || '');
      }}
      value={value}
      renderInput={params => (
        <TextField
          {...params}
          InputProps={{
            ...params.InputProps,
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
          placeholder={label}
          label=""
          variant="outlined"
          fullWidth
        />
      )}
    />
  );
};
